import { render, staticRenderFns } from "./GroupDataTable.vue?vue&type=template&id=9e433a0c&scoped=true&"
import script from "./GroupDataTable.vue?vue&type=script&lang=js&"
export * from "./GroupDataTable.vue?vue&type=script&lang=js&"
import style0 from "./GroupDataTable.vue?vue&type=style&index=0&id=9e433a0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e433a0c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VDataTable})
